import { render } from "./studentinfo.vue?vue&type=template&id=7861a384&scoped=true"
import script from "./studentinfo.vue?vue&type=script&lang=js"
export * from "./studentinfo.vue?vue&type=script&lang=js"

import "./studentinfo.vue?vue&type=style&index=0&id=7861a384&lang=scss&scoped=true"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7861a384"]])

export default __exports__